import React, { useEffect, useState, useMemo } from "react";
import _ from "lodash";
// Import BriefMetadata from "@acadia-ui/brief-metadata";
import Popover, { POPOVER_POSITION } from "@acadia-ui/popover";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
// import Card, { CARD_PADDING } from "@acadia-ui/card";

import "./cellRenderers.scss";

// ci test

export const masterCampaignNameCellRenderer = (campaign, aarc) => {
	// Check if it has any Draft status child campaigns
	const hasDraft = Boolean([].concat(...Object.values(campaign.ActivationCampaigns)).find((activationCampaign) => activationCampaign.IsDraft === "True"));

	return (
		<div style={{ display: "flex", justifyContent: "flex-start", position: "absolute", top: 16, fontSize: "14px" }}>
			{aarc.briefEnabled && campaign.BriefID && (
				<div>
					{/* <BriefMetadata className="isBrief" briefId={campaign.BriefID} aarc={aarc} onClick={e => e.stopPropagation()}> */}
					<i style={{ color: "rgb(63, 169, 245)", marginRight: 10 }} className="icon-briefcase-16" />
					{/* </BriefMetadata> */}
				</div>
			)}
			{hasDraft && <i style={{ paddingRight: 10 }} className="icon-draft" />}
			<div>{campaign.MasterCampaignName}</div>
		</div>
	);
};

export const customDateRenderer = (value) => {
	return (
		<>
			{value &&
				new Date(value)?.toLocaleDateString?.(
					// This comment exists to prevent eslint from making this unreadable.
					"en-US",
					{ year: "numeric", month: "short", day: "2-digit" }
				)}
		</>
	);
};

export const TaxonomyCellRenderer = ({ taxonomy, isPrisma }) => {
	const [used, setUsed] = useState(false);

	const handleCopy = () => {
		navigator.clipboard.writeText(taxonomy);
		setUsed(true);
	};

	useEffect(() => {
		if (used) {
			setTimeout(() => setUsed(false), 3000);
		}
	}, [used]);

	const prismaLengthExceeded = useMemo(() => {
		return isPrisma && taxonomy.length > 256;
	}, [taxonomy, isPrisma]);

	return (
		<Popover
			className={`tx-cell-renderer ${prismaLengthExceeded ? "taxonomy-error" : ""}`}
			trigger={
				<Button display={BUTTON_DISPLAY.ICON} size={BUTTON_SIZE.SMALL} icon="icon-popup" data-tracking-id-alt="open-taxonomy-popover">
					Taxonomy
				</Button>
			}
			position={POPOVER_POSITION.BOTTOM_START}
		>
			<div className="taxonomy-container">
				<div className={"tx-cell-renderer-label"}>{taxonomy}</div>
				<Button display={BUTTON_DISPLAY.PRIMARY} size={BUTTON_SIZE.SMALL} onClick={handleCopy} data-tracking-id-alt="copy-taxonomy">
					{used ? "Copied" : "Copy"}
				</Button>
			</div>
			{prismaLengthExceeded && <div className="prisma-error-message">The taxonomy string exceeds the 256 Prisma character limit. Revise the taxonomy string to proceed.</div>}
		</Popover>
	);
};

export const hideAccordionControlRenderer = (dataProvider, row) => {
	const bindKey = "MasterCampaignUniqueIDCode";
	const dataSet = dataProvider?.filteredData !== undefined ? dataProvider?.filteredData : dataProvider?.data;
	const dataIndex = dataSet?.findIndex((d) => d[bindKey] === row[bindKey]);
	const childDataProvider = dataProvider?.childDataProviders?.[dataIndex];
	if (childDataProvider.data?.length === 0) {
		return <div className="hide-accordion-control"></div>;
	}
	return <div></div>;
};
